import { MOVED_PERMANENTLY } from "http-status-codes";
import { PopoverView } from "../components/popover/popover";
import moment from "moment";
import popOverStore from "@/trust-atcs-app/store";

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $formatDateTimeTypeA: (isoStr: string) => string,
    $formatDate: (isoStr: string) => string,
    $formatMMYYYY: (isoStr: string) => string,
    $formatYYYY: (isoStr: string) => string,
    $formatDateTimeTypeC: (isoStr: string) => string,
    $formatDateTimeTypeD: (isoStr: string) => string,
    $formatSecToHours: (seconds: number) => string,
    $getPopover: (pKey: string, pageId: number) => PopoverView,
    $formatDateFullDate: (isoStr: string) => string,
  }
}

export default {
  methods: {

    $getPopover(pKey: string, pageId?: number): PopoverView {
      try {
        const _popOver = popOverStore.getters.getPopovers.filter((p: { pageId: number; key: string; }) => {
          if (pageId && pageId > 0) {
            return p.key == pKey && p.pageId == pageId;
          } else {
            return p.key == pKey;
          }
        })[0];
        return _popOver;
      } catch (err) {
        return {} as PopoverView;
      }
    },
  
    $formatDateTimeTypeA(isoStr: string): string {
      if (isoStr) {
        return moment(isoStr).format('DD/MM/YYYY HH:mm');
      } else {
        return '';
      }
    },
    $formatDate(isoStr: string): string {
      return isoStr ? moment(isoStr).format('DD/MM/YYYY') : '';
    },
    $formatMMYYYY(isoStr: string): string {
      return isoStr ? moment(isoStr).format('MM/YYYY') : '';
    },
    $formatYYYY(isoStr: string): string {
      return isoStr ? moment(isoStr).format('YYYY') : '';
    },
    $formatDateTimeTypeC(isoStr: string): string {
      return moment(isoStr).format('HH:mm');
    },
    $formatDateTimeTypeD(isoStr: string): string {
      return moment(isoStr).format('DD/MM/YYYY HH:mm');
    },
    $formatSecToHours(seconds: number): string {
      if (seconds > 1) {
        return seconds / 60 + ' hours';
      } else if (seconds == 60) {
        return seconds / 60 + ' hour';
      } else {
        return '';
      }
    },
    $formatDateFullDate(isoStr: string): string {
      return isoStr ? moment(isoStr).format('DD MMM YYYY') : '';
    },
  }
};
